module.exports = __webpack_public_path__ + "static/media/girlscript_logo.ec397b76.jpeg";